// Values shared across the onboarding wizard (components/WelcomeModal).

// "How would you describe yourself?"
export const ACCOUNT_TYPE = {
  FARM: "farm",
  AG_SERVICES: "ag_services",
  CONTRACTOR: "contractor",
  EXISTING_PROPERTY: "existing_property",
};

// Wording/field set for the property-setup steps: a farm's own property, or
// one named after a contractor's / ag services business's company.
export const SETUP_VARIANT = {
  FARM: "farm",
  BUSINESS: "business",
};

export const ONBOARDING_PLAN = {
  BRONZE: "bronze",
  SILVER: "silver",
  GOLD: "gold",
};

// "How are you planning to use AirAgri?" needs an answer, so one starts selected.
export const DEFAULT_PURPOSE = "for_employee_safety";

// `status` of POST properties/access-request.
export const ACCESS_REQUEST_STATUS = {
  APPROVED: "approved",
  PENDING: "pending",
  INVITED: "invited",
};

// `kind` of each row from GET properties/pending-access.
export const PENDING_ACCESS_KIND = {
  REQUEST: "request",
  CONTRACTOR: "contractor",
  INVITATION: "invitation",
};

export const BILLING_PERIOD = {
  MONTHLY: "monthly",
  ANNUAL: "annual",
};

// Prices (AUD) and Stripe price ids for the paid plans. Keep the amounts in step
// with the labels in constants/subscriptionPlan.js and
// config/translation/locales/en_US.json.
export const PAID_PLAN_PRICES = {
  [ONBOARDING_PLAN.SILVER]: {
    [BILLING_PERIOD.MONTHLY]: { amount: 4.95, stripePlan: process.env.REACT_APP_STRIPE_PLAN_SILVER },
    [BILLING_PERIOD.ANNUAL]: { amount: 50, stripePlan: process.env.REACT_APP_STRIPE_PLAN_SILVER_ANNUAL },
  },
  [ONBOARDING_PLAN.GOLD]: {
    [BILLING_PERIOD.MONTHLY]: { amount: 39.95, stripePlan: process.env.REACT_APP_STRIPE_PLAN_GOLD },
    [BILLING_PERIOD.ANNUAL]: { amount: 470, stripePlan: process.env.REACT_APP_STRIPE_PLAN_GOLD_ANNUAL },
  },
};

export const formatPrice = (amount) => `$${amount.toFixed(2)}`;

// The 3-month trial is on Gold monthly.
export const GOLD_MONTHLY_PRICE = formatPrice(
  PAID_PLAN_PRICES[ONBOARDING_PLAN.GOLD][BILLING_PERIOD.MONTHLY].amount
);
